export default __webpack_public_path__ + "static/media/640_dummy2016-kunsthandwerk01-mobile-de.6b03e15e.png";